import type { IconData } from '@stacksjs/iconify-core'

export const x: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m427.314 107.313l-22.628-22.626L256 233.373L107.314 84.687l-22.628 22.626L233.373 256L84.686 404.687l22.628 22.626L256 278.627l148.686 148.686l22.628-22.626L278.627 256z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default x
